import { useQuery } from 'data-fetching-client';
import { GET_PROMOTIONS } from 'pricing-pages-api/promotions/queries';
import { promotionKeys, NO_PROMOTION } from '../../constants/promotions';
export const usePromotionBanners = () => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_PROMOTIONS, {
    variables: {
      earlyRequestName: 'promotions'
    }
  });

  // Extract eligible promotions from the response (same logic as getAllEligiblePromotions)
  const getAllEligiblePromotions = () => {
    var _data$promotions;
    if (!(data !== null && data !== void 0 && (_data$promotions = data.promotions) !== null && _data$promotions !== void 0 && _data$promotions.productsEligibleForDirectPromotions)) return [];
    const allPromotions = Object.values(data.promotions.productsEligibleForDirectPromotions || {});
    const uniquePromotions = {};
    for (const promotion of allPromotions) {
      for (const versionSpecificPromotion of Object.values(promotion)) {
        const {
          eligiblePromotion,
          eligiblePromotionId
        } = versionSpecificPromotion;
        if (eligiblePromotion && eligiblePromotion !== NO_PROMOTION) {
          uniquePromotions[eligiblePromotion] = true;
        }

        // HSFS_SEED_V3 is only returned in eligiblePromotionId field
        if (eligiblePromotionId && eligiblePromotionId !== NO_PROMOTION) {
          uniquePromotions[eligiblePromotionId] = true;
        }
      }
    }
    return Object.keys(uniquePromotions);
  };
  const eligibleDiscounts = getAllEligiblePromotions();
  const isEligibleForPromotion = promotionKey => eligibleDiscounts.includes(promotionKey);
  const bannerConfigs = [{
    shouldShow: isEligibleForPromotion(promotionKeys.HSFS_SEED_V2),
    promotion: promotionKeys.HSFS_SEED_V2,
    titleMessage: 'pricingPage.promotions.hsfx.seed.title',
    descriptionMessage: 'pricingPage.promotions.hsfx.seed.body'
  }, {
    shouldShow: isEligibleForPromotion(promotionKeys.HSFS_SEED_V3),
    promotion: promotionKeys.HSFS_SEED_V3,
    titleMessage: 'pricingPage.promotions.hsfx.seedV3.title',
    descriptionMessage: 'pricingPage.promotions.hsfx.seedV3.body'
  }, {
    shouldShow: isEligibleForPromotion(promotionKeys.HSFX_ENTREPRENEUR_V2),
    promotion: promotionKeys.HSFX_ENTREPRENEUR_V2,
    titleMessage: 'pricingPage.promotions.hsfx.entrepreneur.title',
    descriptionMessage: 'pricingPage.promotions.hsfx.entrepreneur.body'
  }, {
    shouldShow: isEligibleForPromotion(promotionKeys.HSFX_BOOTSTRAP),
    promotion: promotionKeys.HSFX_BOOTSTRAP,
    titleMessage: 'pricingPage.promotions.hsfx.bootstrap.title',
    descriptionMessage: 'pricingPage.promotions.hsfx.bootstrap.body'
  }, {
    shouldShow: isEligibleForPromotion(promotionKeys.STRATEGIC_PARTNERSHIP),
    promotion: promotionKeys.STRATEGIC_PARTNERSHIP,
    titleMessage: 'pricingPage.promotions.hsfx.strategicPartner.title',
    descriptionMessage: 'pricingPage.promotions.hsfx.strategicPartner.body'
  }, {
    shouldShow: isEligibleForPromotion(promotionKeys.HSFS_SERIES_A_V2),
    promotion: promotionKeys.HSFS_SERIES_A_V2,
    titleMessage: 'pricingPage.promotions.hsfx.series-a.title',
    descriptionMessage: 'pricingPage.promotions.hsfx.series-a.body'
  }];
  return {
    bannerConfigs,
    loading,
    error
  };
};